import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const TyreWarrantyPath = '/tyrewarranty'
export const TyreWarrantyCheck = `/tyrewarranty/:requestUUID(${UUIDPathRegex})`
